import React from "react";
import {Box} from "@mui/material";
import ImageOutlinedIcon from "@mui/icons-material/ImageOutlined";
import type {NodeViewProps} from "@tiptap/react";
import PrintoutBlockShell from "../shared/PrintoutBlockShell";
import ImageView from "./ImageView";
import {getPrintoutImageAttrs} from "./printoutImageOptions";
import type {PrintoutImageNodeAttrs} from "./printoutImageOptions";

const PrintoutImageNodeView = (props: NodeViewProps) => {
    const attrs = getPrintoutImageAttrs(props.node.attrs as PrintoutImageNodeAttrs);

    return (
        <PrintoutBlockShell
            {...props}
            blockType="printoutImage"
            icon={<ImageOutlinedIcon fontSize="small"/>}
            label="Image"
        >
            <Box sx={{width: "100%"}}>
                <ImageView attrs={attrs}/>
            </Box>
        </PrintoutBlockShell>
    );
};

export default PrintoutImageNodeView;
